<template>
    <div class="cabinet-content-wrap">
        <header
            class="cabinet-header d-flex align-items-center justify-content-between justify-content-md-start"
        >
            <a
                href="javascript:void(0)"
                class="dashboard__back-link"
                @click="$router.go(-1)"
            ></a>
            <h1 class="h1 cabinet-title pl-3 m-0">Бренды</h1>
            <div class="pr-3 pl-3 pb-1"></div>
        </header>

        <section class="dashboard-list__section pt-2">
            <div class="filters-panel-search dashboard-list__search">
                <label
                    class="filters-panel-search__label"
                    for="filters-panel-search__input"
                    @click="onSearch"
                ></label>
                <input
                    id="filters-panel-search__input"
                    v-model.trim="search"
                    type="text"
                    class="app-input filters-panel-search__input"
                    placeholder="Бренд"
                    @keyup.enter="onSearch"
                />
                <label
                    v-if="search"
                    class="filters-panel-search__clear"
                    for="filters-panel-search__input"
                    @click="onClearSearch"
                ></label>
            </div>

            <div v-if="loading" class="pt-4 mt-3">Loading...</div>

            <div
                v-else-if="!paginatedBrands.length"
                class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
            >
                <img
                    v-if="!search"
                    src="/img/icons/empty-goods.svg"
                    class="dashboard-empty__img ofi"
                />
                <img
                    v-else
                    src="/img/icons/empty-search.svg"
                    class="dashboard-empty__img dashboard-empty__img--search ofi"
                />
                <div class="dashboard-empty__title pt-5">
                    {{
                        search
                            ? ' По вашему запросу ничего не найдено.'
                            : 'Нет информации.'
                    }}
                </div>
            </div>

            <template v-if="!loading && paginatedBrands.length">
                <div class="d-flex justify-content-between pt-4 mt-3">
                    <pagination-info :pagination="pagination" />

                    <div class="d-none d-md-flex">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalProducts"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                </div>

                <div class="pt-4">
                    <a
                        v-for="brand in paginatedBrands"
                        :key="brand.BrandID"
                        class="cabinet-table__row link-nostyle flex flex-align-center pt-3 pb-3"
                        :href="getPublicCatalogLinkByBrand([brand.BrandID])"
                        target="_blank"
                    >
                        <div
                            class="dashboard-list__cell d-flex align-items-center"
                        >
                            <img
                                class="dashboard-list__logo-left ofi"
                                :src="brand.logo"
                            />
                            <div class="pl-3">
                                <div class="dashboard-list__cell-name">
                                    {{ brand.BrandName }}
                                </div>
                                {{
                                    brand.supplier.company_name ||
                                        brand.supplier.name
                                }}
                            </div>
                        </div>
                    </a>
                </div>

                <div class="pt-4 pb-5 mb-3">
                    <div class="d-none d-md-flex justify-content-end">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalProducts"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                    <div
                        v-if="pagination.page < pagination.totalPages"
                        class="d-flex d-md-none justify-content-center pt-2"
                    >
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default"
                            :disabled="pagination.page >= pagination.totalPages"
                            @click="updateList(pagination.page + 1, true)"
                        >
                            Загрузить еще
                        </button>
                    </div>
                </div>
            </template>
        </section>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import PaginationInfo from '@/components/Cabinet/Pagination/PaginationInfo'
import getPublicCatalogLinkByBrand from '@/mixins/getPublicCatalogLinkByBrand'

export default {
    name: 'GlobalBrands',
    components: { TablePagination, PaginationInfo },
    mixins: [getPublicCatalogLinkByBrand],
    data() {
        return {
            loading: true,
            search: ''
        }
    },
    computed: {
        ...mapState('supplierStatsBrands', [
            'brands',
            'mobileBrands',
            'pagination',
            'errors'
        ]),
        paginatedBrands() {
            if (document.documentElement.clientWidth > 767) {
                return this.brands
            }
            return this.mobileBrands
        }
    },
    async mounted() {
        this.updateList(1)
    },
    destroyed() {
        this.clearBrands()
    },
    methods: {
        ...mapActions('supplierStatsBrands', ['getBrands', 'clearBrands']),
        ...mapMutations('supplierStatsBrands', ['SET_PAGINATION']),
        updateList: _.debounce(async function(
            page = 1,
            isMobilePagination = false
        ) {
            let data = { page, isMobilePagination }

            if (this.search) {
                data.search = this.search
            }

            if (isMobilePagination) {
                this.$Progress.start()
            }

            await this.getBrands(data)

            if (Object.keys(this.errors.getBrands).length) {
                this.$notify({
                    text: 'Ошибка',
                    type: 'error'
                })
            }
            this.loading = false
        },
        800),
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.$Progress.start()

            this.updateList(page)
        },
        onSearch() {
            this.$Progress.start()
            this.updateList(1)
        },
        onClearSearch() {
            this.search = ''
            this.$Progress.start()
            this.updateList(1)
        }
    }
}
</script>
